// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3dVS7","info":"Note_info__FTFVF","note":"Note_note__37BmI","actions":"Note_actions__3hFoq"};